import { render, staticRenderFns } from "./VisitaAngiologicaEditComponent.vue?vue&type=template&id=39e53863"
import script from "./VisitaAngiologicaEditComponent.vue?vue&type=script&lang=js"
export * from "./VisitaAngiologicaEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports